import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Card, Col, Row } from "react-bootstrap";
import Background from "../common/Background";
import Flex from "../common/Flex";
import Section from "../common/Section";
import "../../style.css";

import bgShape from "../../assets/img/illustrations/bg-shape.png";
import shape1 from "../../assets/img/illustrations/shape-1.png";
import halfCircle from "../../assets/img/illustrations/half-circle.png";
import Logo from "../navbar/Logo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import AppContext from "../../context/Context";
import { Badge } from "reactstrap";
import sai_logo from "../../../src/assets/img/logos/sai-logo.png"

const AuthCardLayout = ({
  leftSideContent,
  children,
  footer = true,
  height,
}) => {
  const { loginUserDetails, isDark } = useContext(AppContext);
  const isApiPlusExist = sessionStorage.getItem("api_plus_plus")
    ? JSON.parse(sessionStorage.getItem("api_plus_plus"))
    : false;

  return (
    <Section fluid className={`py-0 ${isApiPlusExist && "sai_container"}`}>
      <Row className="g-0 min-vh-100 flex-center">
        <Col sm={10} lg={8} xxl={5} className="py-3 position-relative">
        {/* <Row>
            <Col>
              <img
                className=""
                style={{
                  width: "100%",
                  borderRadius: "0.5em",
                  margin: "0.6em 0",
                  cursor:"pointer"
                }}
                src={"https://sikka.ai/V4/images/banners/ai-banner-jan.png"}
                alt=""
                width="250"
                onClick={()=>{
                  window.open("https://summit.sikkasoft.com/","_blank");
                }}
              />
            </Col>
          </Row> */}
          {!isApiPlusExist && (
            <>
              {/* <Row>
                <Col
                  className="text-left sikka-llm-link"
                  id={isDark ? "dark-llm-auth-header" : "light-llm-auth-header"}
                  style={{ display: "flex" }}
                >
                  <span>
                    <Badge
                      color={`soft-danger`}
                      className="rounded-capsule mr-1 p-2"
                    >
                      New
                    </Badge>
                  </span>
                  <a href={`${process.env.PUBLIC_URL}/sikkaapillm?ref=portal`}>
                    <h4 className="animate-charcter">
                      1. 15+ years of Synthetic Dental Data for your LLM
                      Training/fine tuning
                    </h4>
                  </a>
                </Col>
              </Row>
              <Row>
                <Col
                  className="text-left pt-1 pb-1 sikka-llm-link"
                  id={isDark ? "dark-llm-auth-header" : "light-llm-auth-header"}
                  style={{ display: "flex" }}
                >
                  <span>
                    <Badge
                      color={`soft-danger`}
                      className="rounded-capsule mr-1 p-2"
                    >
                      New
                    </Badge>
                  </span>
                  <a
                    href={`${
                      process.env.PUBLIC_URL
                    }/sikkaapidentalllm?ref=portal`}
                  >
                    <h4 className="animate-charcter">
                      2. First ready to use Specialized Sikka.ai Dental LLM –
                      uses 15+ years of data
                    </h4>
                  </a>
                </Col>
              </Row> */}
            </>
          )}
          <Card
            className={`overflow-hidden z-index-1 ${isApiPlusExist &&
              "sai_card_container"}`}
            style={{ height: height }}
          >
            <Card.Body className="p-0">
              <Row className="h-100 g-0 ">
                <Col
                  md={6}
                  className={`"text-center "  ${!isApiPlusExist &&
                    "card-brand-design"}`}
                  style={{
                    display: "grid",
                    justifyItems: "center",
                  }}
                >
                  <div className="position-relative p-4 pt-md-5 pb-md-7">
                    {!isApiPlusExist && (
                      <Background
                        image={halfCircle}
                        className="bg-auth-card-shape ml-2"
                      />
                    )}
                    <div className="z-index-1 position-relative light">
                      <Logo
                        src={
                          isApiPlusExist
                            ? `https://sikka.ai/V3/img/sikka-ai-logo-white.png`
                            : ""
                        }
                        className={
                          isApiPlusExist
                            ? "sai-logo-brand-design"
                            : "brand-logo-design"
                        }
                        externalURL={"https://www.sikka.ai/oneapi"}
                      />

                      {/* <h4 className="mb-3">Create New Sikka API Account</h4> */}
                      {!isApiPlusExist ? (
                        <>
                          <p className="mb-0 mt-4 mt-md-5 fs--1 fw-semi-bold text-white opacity-100">
                            <div className="d-flex flex-column align-items-start mb-4">
                              <a
                                href="tel:1-800-947-4552"
                                className="text-decoration-underline text-white"
                                rel="noreferrer"
                              >
                                <FontAwesomeIcon
                                  className="mx-2"
                                  icon={faPhone}
                                />
                                1-800-94-SIKKA
                              </a>
                              <a
                                href="http://maps.google.com/?q=2870 Zanker Rd Suite 120, San Jose, CA 95134"
                                className="text-decoration-underline text-white mt-2"
                                rel="noreferrer"
                                target="_blank"
                                style={{ display: "flex" }}
                              >
                                <FontAwesomeIcon
                                  className="mx-2 mt-1"
                                  icon={faLocationDot}
                                />
                                <p className="text-left">
                                  2870 Zanker Rd Suite 120, San Jose, CA 95134
                                </p>
                              </a>
                              <a
                                href="mailto:info@sikka.ai"
                                className="text-decoration-underline text-white"
                                rel="noreferrer"
                                style={{ marginTop: "-10px", display: "flex" }}
                              >
                                <FontAwesomeIcon
                                  className="mx-2 mt-1"
                                  icon={faEnvelope}
                                />{" "}
                                <p className="text-left">info@sikka.ai</p>
                              </a>
                            </div>
                          </p>
                        </>
                      ) : (
                        <>
                          <img
                            src={sai_logo}
                             width="140"
                             height="auto"
                            alt="SAI logo"
                            className="sai_logo_container position-relative pt-md-7 pb-md-4"
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div
                    className={`mt-3 mb-4 mb-md-3 ${
                      isApiPlusExist ? "" : " light"
                    }`}
                    style={{
                      // position: "absolute",
                      bottom: "0%",
                      textAlign: "center",
                    }}
                  >
                    {leftSideContent}

                    <>
                      {isApiPlusExist && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            fontSize: "0.8em",
                          }}
                        >
                          <a
                            href="tel:1-800-947-4552"
                            className="sai_secondary_text"
                            rel="noreferrer"
                          >
                            1-800-94-SIKKA
                          </a>
                          {"|"}
                          <a
                            href="mailto:info@sikka.ai"
                            className="sai_secondary_text"
                            rel="noreferrer"
                          >
                            <p className="text-left">info@sikka.ai</p>
                          </a>
                        </div>
                      )}
                      <Row className="d-flex justify-content-center mb-1">
                        <Col>
                          <Link
                            className="text-decoration-underline text-white"
                            to={{
                              pathname:
                                "https://www.facebook.com/SikkaSoftware",
                            }}
                            target="_blank"
                          >
                            <FontAwesomeIcon
                              className="mx-2"
                              icon={faFacebook}
                            />
                          </Link>
                          <Link
                            className="text-decoration-underline text-white"
                            to={{
                              pathname: "https://twitter.com/SikkaSoftware",
                            }}
                            target="_blank"
                          >
                            <FontAwesomeIcon
                              className="mx-2"
                              icon={faTwitter}
                            />
                          </Link>
                          <Link
                            className="text-decoration-underline text-white"
                            to={{
                              pathname:
                                "https://www.linkedin.com/company/sikka-ai",
                            }}
                            target="_blank"
                          >
                            <FontAwesomeIcon
                              className="mx-2"
                              icon={faLinkedin}
                            />
                          </Link>
                        </Col>
                      </Row>
                      <Row className={`text-center ${"brand-policy"}`}>
                        <Col>
                          <Link
                            className="text-decoration-underline text-white fs--1"
                            to={{
                              pathname:
                                "https://www.sikkasoft.com/terms-of-service",
                            }}
                            target="_blank"
                          >
                            Terms of Service
                          </Link>
                          |
                          <Link
                            className="text-decoration-underline text-white fs--1"
                            to={{
                              pathname:
                                "https://www.sikkasoft.com/privacy-policy",
                            }}
                            target="_blank"
                          >
                            Privacy Policy
                          </Link>
                          |
                          <Link
                            className="text-decoration-underline text-white fs--1"
                            to={{
                              pathname:
                                "https://www.sikkasoft.com/terms-of-service#hipaa",
                            }}
                            target="_blank"
                          >
                            HIPAA Policy
                          </Link>
                        </Col>
                      </Row>

                      <p className="ml-1 mt-2 fs--1 fw-semi-bold text-white opacity-100 text-center">
                        &copy; {new Date().getFullYear()} Copyright Sikka
                        Software Corporation. All Rights Reserved.
                        <br />
                        <span className="fs--2">
                          Leading AI infrastructure as a Service (AIaaS) for
                          Retail Healthcare
                        </span>
                      </p>
                    </>
                  </div>
                </Col>
                <Col
                  md={6}
                  as={Flex}
                  alignItems="center"
                  justifyContent="center"
                  className={
                    isDark
                      ? "text-brand"
                      : isApiPlusExist
                      ? "sai-card-form-brand-design"
                      : "card-form-brand-design"
                  }
                >
                  <div className="p-3 p-md-3 flex-grow-1">{children}</div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
  );
};
AuthCardLayout.propTypes = {
  leftSideContent: PropTypes.node,
  children: PropTypes.node.isRequired,
  footer: PropTypes.bool,
};

export default AuthCardLayout;
